import * as React from 'react'

function SvgCateNews(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path d="M21.764 3v15.408a2.528 2.528 0 01-2.524 2.525H4.946A2.95 2.95 0 012 17.986v-8.86h3.049v.76H2.76v8.1c0 1.206.98 2.187 2.185 2.187a2.19 2.19 0 002.187-2.187V3h14.63zm-.76.76H7.893v14.226a2.94 2.94 0 01-.804 2.019l-.16.168h12.31c.972 0 1.763-.791 1.763-1.765V3.76zm-2.097 12.597v.76h-4.276v-.76h4.276zm-5.435-4.372v5.132H9.99v-5.132h3.483zm-.76.76H10.75v3.612h1.963v-3.612zm6.195 1.426v.76h-4.276v-.76h4.276zm0-2.186v.76h-4.276v-.76h4.276zm0-2.985v.76H9.99V9h8.918zm0-2.185v.76H9.99v-.76h8.918z" />
    </svg>
  )
}

export default SvgCateNews
